import lodash from "lodash";
import React, { forwardRef } from "react";
import {
  experimentStrategy,
  extractPluginsConfig,
  runStrategiesWithCommonUtils,
  themeStrategy
} from "./../wix-ricos-common";
import { RicosEditor } from "./../ricos-editor";
import { isEditorPlugin } from "./../ricos-editor/utils/is-editor-plugin";
import { RICOS_VERSION } from "./../ricos-schema/next-schema";
import { useGetWixClientPromise } from "./../_shared/request-service-provider/use-get-wix-client-promise";
import { runEditorStrategies } from "./runEditorStrategies";
const WixRicosEditor = (props, ref) => {
  const {
    children,
    biSettings,
    instance,
    plugins,
    theme,
    wixExperiments = {},
    visitorUploads,
    msid,
    fileUploadSizeLimit,
    ...rest
  } = props;
  const experiments = experimentStrategy(wixExperiments);
  const { getWixClientPromise } = useGetWixClientPromise(instance);
  const editorPlugins = React.useMemo(() => plugins?.filter(isEditorPlugin), [plugins]);
  const { strategies } = runStrategiesWithCommonUtils({
    plugins: editorPlugins,
    instance,
    biSettings,
    wixRicosVersion: RICOS_VERSION,
    ricosVersion: RICOS_VERSION,
    experiments,
    getWixClientPromise,
    msid
  });
  const _rcProps = lodash.merge(
    strategies,
    runEditorStrategies(
      editorPlugins,
      instance,
      getWixClientPromise,
      biSettings,
      visitorUploads,
      fileUploadSizeLimit
    ),
    extractPluginsConfig(editorPlugins),
    { getWixClientPromise }
  );
  const isBmPlatform = typeof window !== "undefined" && !!window?.ModuleRegistry;
  return /* @__PURE__ */ React.createElement(
    RicosEditor,
    {
      _rcProps,
      experiments: _rcProps.experiments,
      ref,
      theme: themeStrategy(theme, isBmPlatform),
      plugins,
      environment: isBmPlatform ? "businessManager" : "liveSite",
      ...rest
    },
    children
  );
};
var WixRicosEditor_default = forwardRef(WixRicosEditor);
export {
  WixRicosEditor_default as default
};
//# sourceMappingURL=WixRicosEditor.js.map
